export default [
  {
    protocol: 'https',
    hostname: 'static.oc-static.com',
    pathname: '/**',
  },
  {
    protocol: 'https',
    hostname: 'development.oc-static.com',
    pathname: '/**',
  },
  {
    protocol: 'https',
    hostname: 'user.oc-static.com',
    pathname: '/**',
  },
  {
    protocol: 'https',
    hostname: 'course.oc-static.com',
    pathname: '/**',
  },
];
